export default {
  emptyNotice: '일시적으로 콘텐츠가 없습니다',
}
